function rangeMap(val: number, inMin: number, inMax: number, outMin: number, outMax: number): number {
  return ((val - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
}

export default rangeMap;
